export enum PackagingMaterialType {
    DEFAULT = 0,
}